"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "CashBackCustomIcon", {
  enumerable: true,
  get: function get() {
    return _CashbackCustomIcon.CashBackCustomIcon;
  }
});
Object.defineProperty(exports, "CashBackIcon", {
  enumerable: true,
  get: function get() {
    return _CashBackIcon.CashBackIcon;
  }
});
var _CashbackCustomIcon = require("./CashbackCustomIcon");
var _CashBackIcon = require("./CashBackIcon");